import types from './types';
import { RESET_DETAILS } from '../genericDetails/types';
import { CLONE_PREFIX } from '../../constants';

const defaultState = {
  chemicalProduct: null,
  sdsFiles: [],
  initialData: {},
  isLoading: false,
  stateChange: 0,
  cmrClassCalculation: 0,
  hazardsCalculation: 0
};

const getNewChemicalProduct = id => {
  let newChemProd = {
    state: { id: '' },
    liquidCategory: { id: '' }
  };
  if (id) newChemProd.selectedChemicalProduct = { id };
  return newChemProd;
};

const getNewChemicalProductFromCurrent = (chemicalProduct, initialData) => {
  let newChemProd = Object.assign({}, chemicalProduct);

  //set new id from sequence, else will be done on initial data success
  if (initialData && initialData.chemicalProduct && initialData.chemicalProduct.id)
    newChemProd.id = initialData.chemicalProduct.id;
  else newChemProd.id = null;

  newChemProd.selectedChemicalProduct = { id: -1 };
  newChemProd.tradeName = CLONE_PREFIX.concat(newChemProd.tradeName);
  newChemProd.sdsFiles = getNewChemicalProductSdsFilesFromCurrent(newChemProd.sdsFiles);

  newChemProd.scemCode = null;
  newChemProd.validateUser = null;
  newChemProd.validateDte = null;
  newChemProd.updateUser = null;
  newChemProd.updateDte = null;
  newChemProd.createUser = null;
  newChemProd.createDte = null;

  return newChemProd;
};

const getNewChemicalProductSdsFilesFromCurrent = sdsFiles => {
  if (sdsFiles && sdsFiles.length > 0) sdsFiles.forEach(f => (f.fileData.isCloned = true));
  return sdsFiles;
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_CHEMICAL_PRODUCT_INITIAL_DATA:
      return { ...state, initialData: {}, isLoading: true };
    case types.GET_CHEMICAL_PRODUCT_INITIAL_DATA_SUCCESS:
      let chemicalProduct;
      //set new id from sequence for cloning, else will be done on get inventory success
      if (request.params && request.params.isCloneMode)
        chemicalProduct = state.chemicalProduct
          ? { ...state.chemicalProduct, id: data.chemicalProduct.id }
          : state.inventory;
      else chemicalProduct = data.chemicalProduct ? data.chemicalProduct : state.chemicalProduct;

      return { ...state, chemicalProduct: chemicalProduct, initialData: data, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_INITIAL_DATA_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_CHEMICAL_PRODUCT:
      return { ...state, chemicalProduct: null, isLoading: true };
    case types.GET_CHEMICAL_PRODUCT_SUCCESS:
      if (request.params && request.params.isCloneMode)
        data = getNewChemicalProductFromCurrent(data, state.initialData);
      return { ...state, chemicalProduct: data, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_CHEMICAL_PRODUCT_SDS_FILES:
      return { ...state, sdsFiles: [], isLoading: true };
    case types.GET_CHEMICAL_PRODUCT_SDS_FILES_SUCCESS:
      if (request.params && request.params.isCloneMode)
        data.sdsFiles = getNewChemicalProductSdsFilesFromCurrent(data.sdsFiles);
      return { ...state, sdsFiles: data.sdsFiles, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_SDS_FILES_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_CHEMICAL_PRODUCT_TITLE_DETAILS:
      return { ...state, chemicalProductTitleDetails: null, isLoading: true };
    case types.GET_CHEMICAL_PRODUCT_TITLE_DETAILS_SUCCESS:
      return { ...state, chemicalProductTitleDetails: data, isLoading: false };
    case types.GET_CHEMICAL_PRODUCT_TITLE_DETAILS_FAILURE:
      return { ...state, isLoading: false };

    case types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL:
      return { ...state, isLoading: true };
    case types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      if (data.openConfirmationModal) return { ...state, isLoading: false };
      else
        return {
          ...state,
          chemicalProduct: data.chemicalProduct,
          isLoading: false
        };
    case types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_FAILURE:
      return { ...state, isLoading: false };

    case types.DELETE_CHEMICAL_PRODUCT:
      return { ...state, isLoading: true };
    case types.DELETE_CHEMICAL_PRODUCT_SUCCESS:
      return { ...state, isLoading: false };
    case types.DELETE_CHEMICAL_PRODUCT_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_NEW_CHEMICAL_PRODUCT:
      return { ...state, chemicalProduct: getNewChemicalProduct(params.id), isLoading: false };

    case types.GET_NEW_CHEMICAL_PRODUCT_FROM_CURRENT:
      return {
        ...state,
        chemicalProduct: getNewChemicalProductFromCurrent(params.chemicalProduct),
        isLoading: false
      };

    case types.STATE_CHANGE:
      return { ...state, stateChange: state.stateChange + 1 };

    case types.CMR_CLASS_CALCULATION:
      return { ...state, cmrClassCalculation: state.cmrClassCalculation + 1 };

    case types.HAZARDS_CALCULATION:
      return { ...state, hazardsCalculation: state.hazardsCalculation + 1 };

    case RESET_DETAILS:
      return {
        ...defaultState
      };

    default:
      return state;
  }
};
